import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLanguage } from 'react-switch-lang';
import { languageActions } from '../../store/redux/languageSlice';
import styles from './translate.module.scss';

const Translate: React.FC = () => {
  const dispath = useDispatch();
  useState(() => {
    setLanguage(localStorage.getItem('lang') || 'fr');
  });

  const handleSetLanguage = (key) => {
    localStorage.setItem('lang', key);
    setLanguage(key);
    dispath(languageActions.updateCurrentLang(key));
  };

  return (
    <div className={styles['translate-wrapper']}>
      <div className="lang" onClick={() => handleSetLanguage('fr')}>
        <i
          className={`${styles['translate-icon']} flag-icon flag-icon-fr ${
            localStorage.getItem('lang') === 'fr' ? styles['active'] : ''
          }`}
        ></i>
      </div>
      <div className="lang" onClick={() => handleSetLanguage('en')}>
        <i
          className={`${styles['translate-icon']} flag-icon flag-icon-gb ${
            localStorage.getItem('lang') === 'en' ? styles['active'] : ''
          } `}
        ></i>
      </div>
    </div>
  );
};

export default Translate;
